import { Component, Input } from "@angular/core";

@Component({
    selector: "history-modal-item",
    templateUrl: "./historymodalitem.component.html",
    standalone: false
})

export class HistoryModalItemComponent {
    @Input() auditItem: any;
    @Input() isFirst: any;

    public visible: boolean = false;

    /*
     * Toggle content visible/invisible
     */
    toggle(): void {
        this.visible = !this.visible;
    }
}

